import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import * as yup from 'yup';
import { ContactJumbo, EmailIcon, LocationPin, PhoneIcon } from "../../images";
import { CheckCircle, LoaderPinwheel } from 'lucide-react';

const schema = yup.object({
    fullname: yup.string().required('Full Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phone: yup.string().required('Phone Number is required').length(11, 'Phone Number must be 11 digit'),
    help: yup.string().required('What service are you interested in?')
})
const initialState = {
    fullname: '',
    email: '',
    phone: '',
    help: ''
}


const ContactUs = () => {
    const [submitting, setSubmitting] = useState(false)
    const backgroundImageStyle = {
        backgroundImage: `url(${ContactJumbo})`
    };

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState
    });

    const onSubmit = async (data) => {
        const tableRows = Object.keys(initialState).map((key) => {
            return `
                <tr>
                    <th style="border: 1px solid #ddd; padding: 10px; background-color: #f0f5f0;">${key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim()}</th>
                    <td style="border: 1px solid #ddd; padding: 10px;">${data[key]}</td>
                </tr>
            `;
        }).join('');

        try {
            setSubmitting(true)
            // Remove the data URI prefix
            const fd = new FormData()
            Object.entries({
                sender: JSON.stringify({ name: 'Myrtle Lab', email: 'info@myrtlelab.com.ng' }),
                replyTo: JSON.stringify({ name: data.name, email: data.email }),
                to: JSON.stringify([{ email: process.env.REACT_APP_TO_ADDRESS }]),
                subject: "New Contact form Submitted",
                htmlContent: `
						<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
							<h2 style="color: #333;">Contact Form</h2>
              <p style="font-size: 16px; line-height: 24px;">A new Contact Form has been submitted on the website with the following details:</p>
              <table style="border-collapse: collapse; border: 1px solid #ddd;">
                  ${tableRows}
              </table>
              <p style="font-size: 16px; line-height: 24px;"> you can reply to this message</p>
              <p style="font-size: 16px; line-height: 24px;">Best regards,</p>
              <p style="font-size: 16px; line-height: 24px;">Website Admin</p>
						</div>
					`
            }).forEach(([key, value]) => {
                fd.append(key, value)
            })
            const res = await fetch(process.env.REACT_APP_EMAIL_URL, {
                method: 'POST',
                headers: {
                },
                body: fd
            });

            if (res.status === 200) {
                reset();
                toast("Contacts form Submitted Successfully!", {
                    icon: <CheckCircle />,
                    className: 'bg-green-500 text-white'
                })
                // toast.success("RSVP Submitted Successfully!", {
                //   description: "Thank you for your response. We can't wait to celebrate with you!",
                // });
            }

        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false)
        }
    }
    return (
        <div>
            <div style={backgroundImageStyle} className="h-[280px] bg-center bg-cover">
                <div className="bg-[#000000] bg-opacity-[45%] py-[94px] min-[900px]:px-[96px] px-4 h-full">
                    <h1 className="text-[48px] leading-[64px] font-bold text-[#FFFFFF] text-center">Contact Us</h1>
                </div>
            </div>

            <div className="min-[900px]:py-[93px] py-[88px] min-[900px]:px-[80px] flex min-[900px]:flex-row flex-col min-[900px]:gap-[141px] gap-[88px]">
                <div className="py-[84px] min-[900px]:pl-[31px] min-[900px]:pr-[63px] px-4 bg-[#4B7670] min-[900px]:w-[570px] w-full">
                    <h2 className="min-[900px]:text-[36px] text-[34px] leading-[52px] font-semibold text-[#FFFFFF] ">Get In Touch With Us</h2>
                    <p className="text-[16px] leading-[24px] text-[#FFFFFF] mt-[24px]">You are what matter most to us. We provide a tailored service delivery that matches your requirements. Over the phone, at our front desks, or by email,
                        this means a trained and responsive Customer Service team focused on delivering quality and customized services to pair our laboratory competency with your specific needs.
                    </p>

                    <div className="mt-[64px] flex flex-col gap-[48.5px] text-[#FFFFFF] text-[18px] leading-[24px]">
                        <div className="flex gap-4">
                            <img src={PhoneIcon} alt="phone" className="w-[24px] h-[24px]" />
                            <a href="tel:+2349020664276" target="_blank" rel="noreferrer">+234 902 066 4276</a>
                        </div>
                        <div className="flex gap-4">
                            <img src={EmailIcon} alt="email" className="w-[24px] h-[24px]" />
                            <a href="mailto:+info@myrtlelab.com" target="_blank" rel="noreferrer">info@myrtlelab.com</a>
                        </div>
                        <div className="flex gap-4">
                            <img src={LocationPin} alt="email" className="w-[24px] h-[24px]" />
                            <p>No. 19, Dansuleiman Street, Utako, Abuja</p>
                        </div>
                    </div>
                </div>

                <div className="min-[900px]:w-[456px] w-full px-4">
                    <form action="" className="flex flex-col w-full gap-6" onSubmit={handleSubmit(onSubmit)}>
                        <div>
                            <label htmlFor="fullname" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">Full Name <span className="text-[#D34222]">*</span></label>
                            <input
                                type="text"
                                {...register("fullname", { required: true })}
                                id="fullname"
                                placeholder="Type in your full name"
                                className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] .placeholder-color-[#C7CAD8] focus:outline-none"
                            />
                            {errors.fullname && <span className="text-[10px] text-[#D34222]">This field is required</span>}
                        </div>

                        <div>
                            <label htmlFor="email" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">Email <span className="text-[#D34222]">*</span></label>
                            <input
                                type="email"
                                {...register("email", { required: true })}
                                id="email"
                                placeholder="Type in your email"
                                className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] .placeholder-color-[#C7CAD8] focus:outline-none"
                            />
                            {errors.email && <span className="text-[10px] text-[#D34222]">This field is required</span>}
                        </div>

                        <div>
                            <label htmlFor="phone" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">Phone <span className="text-[#D34222]">*</span></label>
                            <input
                                type="phone"
                                {...register("phone", { required: true })}
                                id="phone"
                                placeholder="Type in your phone number"
                                className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] .placeholder-color-[#C7CAD8] focus:outline-none"
                            />
                            {errors.phone && <span className="text-[10px] text-[#D34222]">This field is required</span>}
                        </div>

                        <div>
                            <label htmlFor="help" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block focus:outline-none">Message <span className="text-[#D34222]">*</span></label>
                            <textarea
                                name="help"
                                id="help"
                                {...register("help", { required: true })}
                                placeholder="How can we help you?"
                                className="border-[1px] border-[#C7CAD8] w-full h-[145px] p-[12px]"></textarea>
                            {errors.help && <span className="text-[10px] text-[#D34222]">This field is required</span>}
                        </div>

                        <div className="flex justify-center">
                            <button type="submit" disabled={submitting} className={`h-[48px] ${!submitting ? 'w-[142px]': 'rounded-full px-1'} transition-all bg-[#275A53] text-[#FFFFFF]`}>
                                {submitting && <LoaderPinwheel className="animate-spin" size={38} />}
                                {!submitting && <span>Submit</span>}
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
};


export default ContactUs;